import React, { ReactElement } from 'react';
import { matchPath, NavLink, Outlet, useLocation } from 'react-router-dom';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Card } from 'modules/common';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';

import { dashboardRoutesConfig } from '../../dashboardRoutesConfig';
import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

export function StakeUnstake(): ReactElement {
  const { classes, cx } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  const location = useLocation();

  const isStakePage = matchPath('/', location.pathname);

  return (
    <div className={classes.root}>
      <Card>
        <div className={classes.navigation}>
          <NavLink
            className={({ isActive }) =>
              cx(classes.item, (isStakePage || isActive) && classes.active)
            }
            to={dashboardRoutesConfig.staking.generatePath()}
          >
            {t(keys.stake)}
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              cx(classes.item, isActive && classes.active)
            }
            to={dashboardRoutesConfig.unstaking.generatePath()}
          >
            {t(keys.unstake)}
          </NavLink>
        </div>

        <Outlet />
      </Card>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    height: 'inherit',
    color: theme.palette.secondary.contrastText,
  },
  navigation: {
    display: 'flex',
  },
  item: {
    fontSize: 16,
    fontWeight: 500,
    paddingBottom: theme.spacing(4),
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    borderBottom: `1px solid ${theme.palette.background.default}`,
    cursor: 'pointer',
    flex: 1,
    textAlign: 'center',

    '&:hover': {
      color: theme.palette.secondary.contrastText,
    },
  },
  active: {
    color: theme.palette.secondary.contrastText,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
}));
